import { Component } from "preact";
import { connectWithTranslations } from "../../../../common/helpers/translationsHelpers";
import {
    COUNTRY_FILTER_OPTIONS,
    getMajorCountries,
    getMinorCountries,
    GTM_ID,
    GA4EVENT
} from "../../../constants";
import CheckboxPicker from "../../../../common/components/CheckboxPicker";
import { getKeysOfNotNullValues } from "../../../../common/helpers/objects";

const CountryCheckboxValue = ({ code, text }) => (
    <div class="fxs_c_filter_picker">
        <span class={`fxs_flag fxs_${code.toLowerCase()}`} title={text}></span>
        <span class="fxs_c_country-name">{text}</span>
    </div>
);

class AdvancedCountryFilterDesktop extends Component {
    componentWillMount() {
        const countryTraking = {
            all: "all",
            clear: "clear",
            country: "Country_",
        };
        const countries = getKeysOfNotNullValues(COUNTRY_FILTER_OPTIONS);
        const majorCountries = getMajorCountries(countries);
        const minorCountries = getMinorCountries(countries);

        this.setState({
            countries,
            majorCountries,
            minorCountries,
            countryTraking,
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedCountries !== nextProps.selectedCountries) {
            const selected = this.state.countries.filter((key) =>
                nextProps.selectedCountries.includes(
                    COUNTRY_FILTER_OPTIONS[key]
                )
            );
            this.setState({ selected });
        }
    }

    render(
        { onChange, translate, config, selectedCountries },
        { countries, majorCountries, minorCountries, countryTraking }
    ) {
        const majorSelected = getSelected(majorCountries, selectedCountries);
        const minorSelected = getSelected(minorCountries, selectedCountries);

        return (
            <div class="fxs_c_advanced-countries-filter">
                <h4 class="fxs_headline_tiny  fxs_marginBase_vertical">
                    <span>{translate("CountryFilterTitle")}</span>
                    <span class="fxs_c_all-none">
                        <button
                            type="button"
                            class="fxs_btn fxs_btn_anchor fxs_btn_xsmall"
                            data-gtmid={
                                config.tracking &&
                                GTM_ID.ADVANCED_FILTERS_COUNTRY_CHECKBOX(
                                    countryTraking.all
                                )
                            }
                            data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                            data-ga4event-element={
                                config.tracking &&
                                GA4EVENT.ELEMENTS.ADVANCED_FILTERS_COUNTRY_CHECKBOX
                            }
                            data-ga4event-country = {config.tracking && countryTraking.all.toLowerCase()}
                            onClick={() => onChange(getValues(countries, []))}
                        >
                            <span>
                                <span>
                                    {translate("AdvancedFilterAllLabel")}
                                </span>
                            </span>
                        </button>
                        <span class="fxs_c_slash-divider">/</span>
                        <button
                            type="button"
                            class="fxs_btn fxs_btn_anchor fxs_btn_xsmall"
                            data-gtmid={
                                config.tracking &&
                                GTM_ID.ADVANCED_FILTERS_COUNTRY_CHECKBOX(
                                    countryTraking.clear
                                )
                            }
                            data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                            data-ga4event-element={
                                config.tracking &&
                                GA4EVENT.ELEMENTS.ADVANCED_FILTERS_COUNTRY_CHECKBOX
                            }
                            data-ga4event-country = {config.tracking && countryTraking.clear.toLowerCase()}
                            onClick={() => onChange([])}
                        >
                            <span>
                                <span>
                                    {translate("AdvancedFilterNoneLabel")}
                                </span>
                            </span>
                        </button>
                    </span>
                </h4>

                <CheckboxPicker
                    onChange={(values) =>
                        onChange(getValues(values, minorSelected))
                    }
                    values={majorCountries}
                    checkedValues={majorSelected}
                    renderTitle={() => { }}
                    renderValue={(value) => (
                        <CountryCheckboxValue
                            code={COUNTRY_FILTER_OPTIONS[value]}
                            text={translate(value)}
                        />
                    )}
                    getOptionGtmId={(key) =>
                        config.tracking &&
                        GTM_ID.ADVANCED_FILTERS_COUNTRY_CHECKBOX(
                            key
                                .replace(countryTraking.country, "")
                                .toLowerCase()
                        )
                    }
                    getOptionGA4Id={(key) =>
                        config.tracking &&
                        GA4EVENT.ELEMENTS.ADVANCED_FILTERS_COUNTRY_CHECKBOX
                    }
                    getOptionGa4ThirdTrackingId={
                        (key)=>({"data-ga4event-country":`${key.replace(countryTraking.country, "").toLowerCase()}`})}
                    getGa4Name={
                        config.tracking &&
                        GA4EVENT.NAMES.FEATURES_CALENDAR
                    }
                />

                <div class="fxs_clearfix" />
                <div class="fxs_marginBase_vertical" />
                <div class="fxs_clearfix" />

                <CheckboxPicker
                    onChange={(values) =>
                        onChange(getValues(majorSelected, values))
                    }
                    values={minorCountries}
                    checkedValues={minorSelected}
                    renderTitle={() => { }}
                    renderValue={(value) => (
                        <CountryCheckboxValue
                            code={COUNTRY_FILTER_OPTIONS[value]}
                            text={translate(value)}
                        />
                    )}
                    getOptionGtmId={(key) =>
                        config.tracking &&
                        GTM_ID.ADVANCED_FILTERS_COUNTRY_CHECKBOX(
                            key.replace("Country_", "").toLowerCase()
                        )
                    }
                    getOptionGA4Id={(key) =>
                        config.tracking &&
                        GA4EVENT.ELEMENTS.ADVANCED_FILTERS_COUNTRY_CHECKBOX
                    }
                    getOptionGa4ThirdTrackingId={
                        (key)=>({"data-ga4event-country":`${key.replace("Country_", "").toLowerCase()}`})}

                    getGa4Name={
                        config.tracking &&
                        GA4EVENT.NAMES.FEATURES_CALENDAR
                    }
                />
            </div>
        );
    }
}

const getSelected = (countries, selected) =>
    selected.length === 0
        ? []
        : countries.filter((key) =>
            selected.includes(COUNTRY_FILTER_OPTIONS[key])
        );

const getValues = (selected, others) => {
    const result = selected
        .concat(others)
        .map((x) => COUNTRY_FILTER_OPTIONS[x]);
    return result;
};

export default connectWithTranslations("config")(AdvancedCountryFilterDesktop);
